import InvoiceAzure from '../../models/InvoiceAzure'
import requestAction from '../../utils/requestAction'

export const fetchInvoiceAzure = (params: string, handleResponse?: (doc: InvoiceAzure) => void, handleError?: (error: Error) => void ) => 

  requestAction('INVOICE_AZURE', params)(`invoicesazure`, 'GET',
  undefined,
  undefined,
  undefined,
  (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response.doc) },
  ( _dispatch, err ) => { if( err && handleError ) handleError( err ) })
